import { Grid, Step, StepLabel, Stepper } from '@material-ui/core';
import AddressGrid from 'components/address-grid';
import Button from 'components/button';
import { Field, Form, Textarea } from 'components/forms';
import { signForm } from 'components/forms/decorators';
import NewProductPicker from 'components/new-product-picker';
import SectionTitle from 'components/section-title';
import { autobind } from 'core-decorators';
import { reverse } from 'core/urls';
import { getDefaultAddress } from 'core/utils';
import createFenceSignsMultiplierOrderMutation from 'graphql/mutations/orders/create-fence-signs-multiplier.gql';
import React, { Component, Fragment } from 'react';
import styles from '../styles.css';
@signForm(createFenceSignsMultiplierOrderMutation, 'fence_signs_multiplier')
@autobind
export default class FenceSignsCreate extends Component {
    state = {
        activeStep: 0,
    };

    getSteps() {
        return ['Productos', 'Envío'];
    }
    
    render() {

        const steps = this.getSteps();

        const handleNext = () => {
            this.setState({activeStep: this.state.activeStep + 1});
        };

        const handleBack = () => {
            this.setState({activeStep: this.state.activeStep - 1}); 
        };

        return (
            <div className={styles.root}>
                <SectionTitle title='Carteles de alambrado' />
                <Stepper activeStep={this.state.activeStep} style={{px: 0 }} alternativeLabel>
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                <Form
                    fields={[
                        {key: 'items', initial: []},
                        {key: 'notes', required: false},
                        {
                            key: 'address',
                            initial: getDefaultAddress(this.props.addressesData),
                        },
                    ]}
                    errors={this.props.errors}
                    onSubmit={this.props.onSubmit}>
                    {({getFieldProps, renderErrors, isValid, values}) => (
                         <Fragment>
                         {this.state.activeStep === 0 &&
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <Field>
                                        <NewProductPicker
                                            items={this.props.itemsData.signs}
                                            perItemLimit={this.props.itemsData.perItemLimit}
                                            toggleSelectedProduct={this.props.toggleSelectedProduct}
                                            {...getFieldProps('items')}
                                        />
                                        {renderErrors('items')}
                                    </Field>
                                </Grid>
                                <Grid item xs={12} style={{marginBottom: 20}}>
                                    <Field label='Comentarios'>
                                        <Textarea {...getFieldProps('notes')} />
                                        {renderErrors('notes')}
                                    </Field>
                                </Grid>
                                <Grid item container justify='flex-end' xs={12}>
                                        <Grid item xs={4}>
                                            <Button fullWidth theme='yellow' disabled={renderErrors('notes') || renderErrors('items') || values.items.length === 0} onClick={handleNext}>
                                                Enviar
                                            </Button>
                                        </Grid>
                                </Grid>
                            </Grid>
                            }
                            {this.state.activeStep === 1 &&
                                <Grid container>
                                    <Grid item xs={12}>
                                        <Field label='Dirección de envío de los carteles'>
                                            <AddressGrid
                                                addresses={this.props.addressesData.addresses}
                                                returnUrl={reverse('fenceSignsMultiplierCreate')}
                                                returnData={values}
                                                {...getFieldProps('address')}
                                            />
                                            {renderErrors('address')}
                                        </Field>
                                    </Grid>
                                    <Grid item>
                                        {renderErrors('__all__')}
                                    </Grid>
                                    <Grid item container xs={12} justify='space-between' alignItems='center'>
                                        <Grid item>
                                            <button type='button' style={{fontWeight:600}} onClick={handleBack}>
                                                Volver
                                            </button>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Form.Actions>
                                                <Button fullWidth theme='yellow' disabled={!isValid() || this.props.loading}>
                                                    {this.props.loading ? 'ENVIANDO...' : 'ENVIAR'}
                                                </Button>
                                            </Form.Actions>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                 }
                                 </Fragment>
                    )}
                </Form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/fence-signs/multiplier/create/index.js